<template>
    <div class="homepage backoffice soldquote" :key="key">

        <div class="backoffice--sidebar" v-if="soldquote.soldquote_status != 'booked'">
            <div class="backoffice--sidebar--action">
                <div class="backoffice--sidebar--icon" @click="api_send_reservations_info" title="salva"><font-awesome-icon size="lg" icon="save"/></div>
            </div>
            <div class="backoffice--sidebar--action">
              <div class="backoffice--sidebar--icon" @click="api_save_soldquote" title="contrassegna come emesso (prenotazioni effettuate)"><font-awesome-icon size="lg" icon="globe"/></div>
            </div>
        </div>

        <b-container fluid>
            <b-row>
                <b-col cols="10" lg="10">
                    <div class="backoffice--head" v-if="Object.keys(soldquote).length > 0">
                        <div class="status">
                            <span>status:</span>
                            <b-badge variant="info">{{ soldquote.soldquote_status }}</b-badge>
                            <span v-if="soldquote.soldquote_status == 'booked'">&nbsp;&nbsp;(non modificabile)</span>
                        </div>
                        <div class="backoffice--actions">
                            <div class="backoffice--action modal-request" v-b-modal.modal-request>
                                Vedi prodotto acquistato
                                <b-modal id="modal-request" title="Richiesta utente" size="lg">
                                    <p>
                                      <strong>payload</strong>
                                      <pre>{{ soldquote }}</pre>
                                    </p>
                                </b-modal>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>

                <b-col cols="12" lg="10">
                  <div class="backoffice--content">
                    <h2 v-html="quote_title"></h2>
                    {{user.name_surname}} {{user.email}} {{user.phone}}
                  </div>
                </b-col>


                <b-col cols="12" lg="10">
                    <div class="backoffice--content">
                        <div class="soldquote--private-data">
                            <div v-for="service in soldquote.services" v-bind:key="service.service_index">
                                <b-alert show variant="warning">
                                    <div class="d-flex align-items-center">
                                        <strong class="mr-2">{{service.details.title}}</strong>
                                        <small> {{ service.private_data.supplier }} | {{ service.private_data.supplier_quote_id }} | € {{ service.private_data.supplier_price }}</small>
                                    </div>
                                    <div>
                                        <small v-html="service.private_data.private_notes"></small>
                                    </div>
                                </b-alert>
                            </div>
                        </div>

                        <br/>

                        <h4>Note per utente (pubbliche, visibili dopo pubblicazione)</h4>
                        <b-form-group id="agent_notes" label="" label-for="">
                            <tiny-mce
                                :initial_value="this.reservations_info"
                                @input="(value) => {
                                    this.reservations_info = value
                                }"
                            />
                        </b-form-group>

                        <hr>
                        <h4>Note private</h4>
                        <b-form-group id="private_notes" label="" label-for="">
                          <tiny-mce
                              :initial_value="this.private_notes"
                              @input="(value) => {
                                        this.private_notes = value
                                    }"
                          />
                        </b-form-group>
                        <!--<textarea rows="5" class="form-control form-control-sm" v-model="reservations_info"></textarea>-->
                        <!--<button style="margin:10px" type="button" class="btn btn-secondary badge" @click="api_send_reservations_info(soldquote.soldquotes_id)">aggiorna informazioni di prenotazione</button>-->
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>    
</template>

<script>
import TinyMce from '@/components/blocks/tiny-mce'
import { send_booked_notification, get_active_soldquote, send_reservations_info, post_heartbeat_soldquotes } from '@/api'
import Vue from "vue";

export default {
    name: 'single-soldquote',
    components: {
        'tiny-mce': TinyMce
    },
    props: {
        soldquotes_id: String,
    },
    computed: {
        soldquote: {
            get() {
                return this.$store.state.soldquote
            },
            set(value)
            {
                this.$store.commit('set_soldquote', value)
            },
        },
    },
    data() {
        return {
            reservations_info: '',
            private_notes: '',
            key: 1,
            hearbeat_timeout: null,
            quote_title: '',
            user: {},
        }
    },
    beforeMount()
    {
    },
    mounted()
    {
        get_active_soldquote({
                soldquotes_id: this.soldquotes_id
            })
            .then(
                (success) => {
                    this.reservations_info = success.data.soldquote.reservations_info
                    this.private_notes = (success.data.soldquote.private_notes)? success.data.soldquote.private_notes : ''
                    this.soldquote = success.data.soldquote.quote_published_content
                    this.quote_title = success.data.soldquote.quote_title,
                    this.user = {
                      name_surname: success.data.soldquote.name_surname,
                      email: success.data.soldquote.user_email,
                      phone: success.data.soldquote.user_phone,
                    }
                    this.key++
                }
            )


        post_heartbeat_soldquotes({soldquotes_id: this.soldquotes_id}) // pingo subito

        if(Vue.prototype.$config.config.heartbeat_seconds && Vue.prototype.$config.config.heartbeat_seconds > 0) {

          this.heartbeat_timeout = this.heartbeat_ping()

        }

    },
    destroyed(){
      clearTimeout(this.heartbeat_timeout)
    },
    methods:
    {

        heartbeat_ping(){

          let _this = this
          return setTimeout(function () {

            post_heartbeat_soldquotes({soldquotes_id: _this.soldquotes_id}) // pingo ogni x
                .then(
                    (success) => {
                      (success)
                      _this.heartbeat_timeout = _this.heartbeat_ping()
                    },

                    (error) => {
                      (error)
                      _this.log('heartbeat_ping error')
                    }
                )

          }, Vue.prototype.$config.config.heartbeat_seconds * 1000);

        },

        update_quote_general_info()
        {
            this.$store.commit('set_quote_general_info', {
                soldquotes_id: this.soldquote.soldquotes_id,
                created_at: this.soldquote.created_at,
            })
        },


        api_send_reservations_info()
        {
          send_reservations_info({
            soldquotes_id: this.soldquotes_id,
            reservations_info: this.reservations_info,
            private_notes: this.private_notes
          })
              .then(

                  (success) => {
                    (success)
                    Vue.$toast.success('salvato')
                    this.soldquote.soldquote_status = 'working'
                    //this.$router.go()
                  }

              )
        },


        api_save_soldquote()
        {

            if(!confirm('Confermi che tutte le prenotazioni sono state fatte? La pratica sarà chiusa e l\'utente informato')) return



            send_reservations_info({
              soldquotes_id: this.soldquotes_id,
              reservations_info: this.reservations_info,
              private_notes: this.private_notes
            })
                .then(

                    (success) => {
                      (success)

                      Vue.$toast.success('salvato')
                      this.soldquote.soldquote_status = 'working'


                      let payload = {
                        soldquotes_id: this.$store.state.soldquote.soldquotes_id,
                      }


                      send_booked_notification(payload)
                          .then(

                              (success) => {

                                this.result = success.result
                                Vue.$toast.success('confermato prenotato')

                                this.$router.push({
                                  name: 'soldquotes',
                                })
                              },

                              (error) => {
                                (error)
                              }

                          )


                    } // send_reservations_info success

                ) // send_reservations_info then

        }, // send_reservations_info


        validate_for_review(){
            // TODO
            return true
        },

        validate_for_publish(){
            // TODO
            return true
        }        
    },
}
</script>


<style lang="scss">
    .backoffice
    {
        &--sidebar
        {
            margin-top:$grid-gutter-width;
            width:80px;
            position:fixed;
            top:$backoffice-head-height;
            left:0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            padding-left: $grid-gutter-width/2;
            &--action
            {
                width:100%;
                display:inline-flex;
                align-items:center;
                justify-content: center;
                padding:0.5rem 1rem;
                margin-bottom:1rem;
                border:2px solid $primary;
                color:$primary;
                border-radius: $border-radius;
                transition:$transition-base;
                font-size: 20px;
                cursor: pointer;
                &:hover
                {
                    background: $primary;
                    color: $white;
                }
                &--icon
                {
                }
            }
        }
        &--content
        {
            margin-top:40px;
        }
        &--head
        {
            position:fixed;
            z-index: 1;
            top:$backoffice-head-height;
            left:$backoffice-sidebar-width + $grid-gutter-width/2;
            right:$grid-gutter-width/2;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding:$grid-gutter-width/2 0 $grid-gutter-width/2 0;
            background:$white;
            .form-group
            {
                margin-right:1rem;
                margin-bottom:0;
            }
            label
            {
                margin-bottom:0;
                font-size: $font-size-sm;
            }
        }
        .status
        {
            color:$info;
            span
            {
                display:inline-block;
                padding-right:10px;
                font-size: 12px;
                text-transform:uppercase;
                font-weight: bold;
            }
        }
        .modal-request
        {
            border-color:$info;
            background:$info;
            color:$white;
            text-transform: uppercase;
            font-weight: bold;
        }
        &--soldquote
        {
            display:flex;
        }
        &--actions
        {
            display:flex;
            align-items:center;
            justify-content: flex-start;
        }
        &--action
        {
            font-size:14px;
            display:inline-flex;
            align-items:center;
            justify-content: flex-end;
            padding:0.25rem 0.75rem;
            margin-left:1rem;
            border:1px solid $secondary;
            color:$secondary;
            border-radius: $border-radius;
            transition:$transition-base;
            background:$white;
            cursor: pointer;
            &:hover
            {
                background: $secondary;
                color: $white;
            }
            &:first-child
            {
                margin-left:0;
            }
            &--icon
            {
                margin-right:0.5rem;
            }
        }        
    }

    .soldquote
    {
        &--private-data
        {
            margin-bottom:1rem;
        }
    }
</style>
